var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.707,
    height: 22.707,
    viewBox: "0 0 22.707 22.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_378",
    "data-name": "Grupo 378",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    fill: "none",
    stroke: "#1d1b26",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.385,
    cy: 10.385,
    r: 10.385,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.385,
    cy: 10.385,
    r: 9.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_77",
    "data-name": "Linha 77",
    x2: 4.103,
    y2: 4.103,
    transform: "translate(17.897 17.897)",
    fill: "none",
    stroke: "#1d1b26",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ce5a3f1d.svg";
export { ForwardRef as ReactComponent };